import { Injectable, inject } from '@angular/core';
import { API_BASE_URL } from '@core/api/api.tokens';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';

export interface ApiWorkTimeDto {
    accumulatedPauseSeconds: number;
    accumulatedWorkSeconds: number;
    currentPauseStartTime: string | null; // 'HH:mm:ss.fffffff' oder null
    currentWorkStartTime: string | null;  // 'HH:mm:ss.fffffff' oder null
}

@Injectable({ providedIn: 'root' })
export class TimeTrackingBarApi {
    private http = inject(HttpClient);

    private baseUrl = inject(API_BASE_URL).replace(/\/+$/, '');

    /**
     * Aktueller Lauf-Status. 204 No Content -> inaktiv/null.
     */
    getCurrent(): Observable<ApiWorkTimeDto | null> {
        return this.http
            .get<ApiWorkTimeDto | null>(`${this.baseUrl}/work-time/sessions/running`, { observe: 'response' })
            .pipe(map((res: HttpResponse<ApiWorkTimeDto | null>) => (res.status === 204 ? null : (res.body ?? null))));
    }

    start(): Observable<ApiWorkTimeDto> {
        return this.http.post<ApiWorkTimeDto>(`${this.baseUrl}/work-time/start`, {});
    }

    pause(): Observable<ApiWorkTimeDto> {
        return this.http.post<ApiWorkTimeDto>(`${this.baseUrl}/work-time/pause`, {});
    }

    resume(): Observable<ApiWorkTimeDto> {
        return this.http.post<ApiWorkTimeDto>(`${this.baseUrl}/work-time/resume`, {});
    }

    stop(): Observable<ApiWorkTimeDto | null> {
        return this.http.post<ApiWorkTimeDto | null>(`${this.baseUrl}/work-time/stop`, {});
    }
}
